const getters = {
  userInfo: state => state.user.userInfo,
  phone: state => state.user.phone,
  token: state => state.user.token,
  mwList: state => state.user.mwList,
}
export default getters
